export const PASSWORD_RESET_MESSAGE = 'You have successfully reset your password. Please log in with your new password.';
export const EMAIL_CONFIRMED_MESSAGE = 'Your email address has been confirmed. Please log in with your new email.';